import { action, decorate, observable } from 'mobx';

import {
  getWallet,
  getTrxHistory,
  getWalletStatSummary,
  getWalletGraphSummary,
  postCashback,
  activateWallet,
} from '../services/CekSaldoService';

class CekSaldoStore {
  barcode = '';
  wallet = {};
  trxHistory = [];

  isLoading = false;
  cashback = {};
  graphSummary = {};

  getWalletStatSummary = async ({ walletId }) => {
    const { data, error } = await getWalletStatSummary({ address: walletId });

    if (data) {
      this.wallet = { ...this.wallet, statusSummary: data };
      return { data };
    } else {
      return { error };
    }
  };
  getWalletGraphSummary = async ({ walletId, duration = 1, unit = 'week' }) => {
    const params = {
      address: walletId,
      duration: duration,
      unit: unit,
    };
    const { data, error } = await getWalletGraphSummary(params);

    if (data) {
      this.graphSummary = data;
      return { data };
    } else {
      return { error };
    }
  };
  getWallet = async ({ walletId }) => {
    this.isLoading = true;

    const { data, error } = await getWallet({ walletId: walletId });

    if (data) {
      this.wallet = data;
      this.isLoading = false;
      return { data };
    } else {
      this.isLoading = false;
      return { error };
    }
  };
  activateWallet = async ({ walletId }) => {
    this.isLoading = true;

    const { data, error } = await activateWallet({ walletId: walletId, currentcy: 'BTC' });

    if (data) {
      this.wallet = data;
      this.isLoading = false;
      return { data };
    } else {
      this.isLoading = false;
      return { error };
    }
  };
  getTrxHistory = async ({ walletId, mode = 'DEPOSIT' }) => {
    this.isLoading = true;
    const postData = {
      address: walletId,
      before: Date.now(),
      mode: mode,
    };
    const { data, error } = await getTrxHistory(postData);

    if (data) {
      this.trxHistory = data;
      this.isLoading = false;
      return { data };
    } else {
      this.isLoading = false;
      return { error };
    }
  };
  postCashback = async ({ walletId }) => {
    const postData = {
      address: walletId,
    };

    const { data, error } = await postCashback(postData);

    if (data) {
      this.cashback = data;
      this.isLoading = false;
      return { data };
    } else {
      this.isLoading = false;
      return { error };
    }
  };
  setBarcode = barcode => {
    this.barcode = barcode;
  };
  prepareDefaultValue = () => {
    this.barcode = '';
    this.wallet = {};
  };
}

decorate(CekSaldoStore, {
  graphSummary: observable,
  barcode: observable,
  wallet: observable,
  isLoading: observable,
  trxHistory: observable,
  cashback: observable,
  postCashback: action,
  getWalletGraphSummary: action,
  getWalletStatSummary: action,
  getTrxHistory: action,
  getWallet: action,
  setBarcode: action,
  prepareDefaultValue: action,
});
export default new CekSaldoStore();
